import React, { Fragment } from 'react';

import { LayoutGrid } from '@ifs-gcp/components';
import type { ITemplateNode } from '@ifs-gcp/core';
import type { CardChild, Language, QuestionSizes } from '@ifs-gcp/core/models';

import { PageCard } from '@/components/page-card';
import type { FactoryElementProps } from '@/features/audit/audit-elements/factory-element';
import { getCardProps, groupChildrenBySize, sizeToNumber } from '@/utils/card';
import { getTranslation } from '@/utils/translations';

import styles from './card.module.scss';

type CardProps = {
  element: ITemplateNode<CardChild>;
  language: Language;
  FactoryElement: React.FC<FactoryElementProps>;
};

export const Card = ({ element, language, FactoryElement }: CardProps) => {
  const { cardTitle, cardBody: cardBodyChildren } = getCardProps(element.children);
  const groupedChildren = groupChildrenBySize(cardBodyChildren);

  return (
    <div className={styles.wrapper}>
      <PageCard
        cardHeaderProps={{
          ...(cardTitle && {
            title: getTranslation(cardTitle, language),
          }),
        }}
      >
        <LayoutGrid container columnSpacing={2.5}>
          {groupedChildren.flatMap((group, topIndex) => (
            <Fragment key={`${group[0].type}-${topIndex}`}>
              {group.map((item, index) => (
                <LayoutGrid
                  key={`${item.type}-${index}`}
                  item
                  xs={sizeToNumber(
                    'size' in item.props ? (item.props.size as QuestionSizes) : undefined,
                  )}
                >
                  <FactoryElement element={item} />
                </LayoutGrid>
              ))}
            </Fragment>
          ))}
        </LayoutGrid>
      </PageCard>
    </div>
  );
};
